import { FC, useRef, useCallback, useEffect } from 'react';
import Dialog, { DialogProps } from 'rc-dialog';
import './base-modal.less';

// https://www.npmjs.com/package/rc-dialog
export interface BaseModalProps extends DialogProps {}
const BaseModal: FC<BaseModalProps> = ({
  visible = false,
  maskClosable = false,
  className = '',
  children,
  animation = 'zoom',
  ...rest
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const fn = useCallback(() => {
    const wh = document.body.clientHeight;
    const dom = contentRef.current;
    if (dom) {
      const { clientHeight } = dom;
      if (clientHeight < wh) {
        dom.style['marginTop'] = `${(wh - clientHeight) * 0.5}px`;
      } else {
        dom.style['margin'] = '10px auto';
      }
    }
  }, [contentRef]);
  useEffect(() => {
    window.addEventListener('resize', fn, false);
    return () => {
      window.removeEventListener('resize', fn, false);
    };
  }, [fn]);
  useEffect(() => {
    if (visible && children) {
      // setTimeout后才可以获取到内部dom
      setTimeout(() => {
        // 第一次显示内容的时候设置居中，之后内容变化后还要设置，保持居中
        fn();
      });
    }
  }, [visible, fn, children]);
  return (
    <Dialog
      closable={false}
      animation={animation}
      maskAnimation="fade"
      destroyOnClose={true}
      visible={visible}
      maskClosable={maskClosable}
      {...rest}
    >
      <div className={className} ref={contentRef}>
        {children}
      </div>
    </Dialog>
  );
};

export default BaseModal;
